import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { BookShipmentShipmentType } from "@/Shared/Types/bookShipmentSliceTypes";
import { bookShipmentShouldShowDeadlineSection } from "./bookShipmentShouldShowDeadlineSection";

/**
 * Drops one end's deadline when its location won't show the question.
 *
 * The deadline lives on the shipment, not the location, so hiding the field
 * isn't enough — a value entered earlier survives out of sight and gets booked.
 * Every path that puts a location into state calls this afterwards, which is
 * why the rule lives here rather than being spelled out at each one.
 */
export function bookShipmentDropHiddenDeadline(
  shipment: BookShipmentShipmentType,
  context: LocationContext,
) {
  if (context === LocationContext.Pickup) {
    if (
      !bookShipmentShouldShowDeadlineSection(shipment.pickupLocation, context)
    ) {
      shipment.pickupDeadline = undefined;
    }
    return;
  }

  if (
    !bookShipmentShouldShowDeadlineSection(shipment.deliveryLocation, context)
  ) {
    shipment.deliveryDeadline = undefined;
  }
}
